import { DocumentStatus } from '@synergy/models';
import { LegacyDateRangeFilter, StatusFilter } from '@synergy/components';
import { PaloFilterModal } from '@synergy/components-palo';

import { ClassificationsFilter } from '../../../common/components/filter/classifications-filter';
import { CustomerContactFilter } from '../../../common/components/filter/customer-contact-filter';
import { CustomerFilter } from '../../../common/components/filter/customer-filter';
import { LegacySupplierFilter } from '../../../common/components/filter/legacy-supplier-filter';
import { ResponsibleContactFilter } from '../../../common/components/filter/responsible-contact-filter';
import { SalesOrderTypeFilter } from '../../../common/components/filter/salesorder-type-filter';
import { fetchAllClassifications } from '../../configuration/organization/classifications/store/classifications-actions';
import { useAppSelector } from '../../../store/use-appstate-selector';
import { useThunkDispatch } from '../../../store/use-thunk-dispatch';

export const DashboardFilterModal = () => {
    const dispatch = useThunkDispatch();
    const classifications = useAppSelector(state => state.classifications.classifications.items);

    return (
        <PaloFilterModal>
            <LegacyDateRangeFilter />
            <ResponsibleContactFilter />
            <StatusFilter
                documentStatus={[
                    DocumentStatus.Created,
                    DocumentStatus.Ongoing,
                    DocumentStatus.Completed,
                    DocumentStatus.CompletedWithTransition,
                    DocumentStatus.CompletedWithoutTransition,
                    DocumentStatus.Canceled,
                ]}
            />
            <SalesOrderTypeFilter />
            <CustomerFilter />
            <CustomerContactFilter />
            <LegacySupplierFilter />
            <ClassificationsFilter
                classifications={classifications}
                fetchClassifications={() => dispatch(fetchAllClassifications())}
            />
        </PaloFilterModal>
    );
};
